import React, { useEffect, useState } from "react";
import { getClientAPI } from "../service/UserService";
import { getUsersWithUserTypeAPI } from "../service/UserService";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  updateCommissionAPI, updateUserStatusAPI, sendLoginDetailsAPI,
  unSettledBetsAPI,
  ChangeClientStatusAPI,
  changePasswordAPI,
} from "../service/AuthService";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import Loader from "./components/Loader";
import SendLoginDetails from "./components/SendLoginDetails";
import store from "../redux/store";
import { Dropdown, Button, Menu } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { DownOutlined } from "@ant-design/icons";
import { PERMISSION_MAP, PERMISSION_MAP_CLIENT } from "../utils/constants";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Encrypt } from "../utils/constants";



export default function MyClients() {
  const [showSendLoginDetails, setShowSendLoginDetails] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = useState("");
  const [userTypeName, setUserType] = useState('');
  const [clientData, setClientData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [userTypeList, setGetUsersWithUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(50);
  const [userId, setGetUserId] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const { userType, userName } = useParams();
  const location = useLocation();
  const [isActive, setIsActive] = useState(null);
  const [selectedClientDW, setSelectedClientDw] = useState({});
  const [amount, setAmount] = useState(0);
  const [depositModal, setShowDeposit] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [changePassword, setChangePassword] = useState(null);
  const [clientPasswordData, setClientPasswordData] = useState(null);


  const userData = store.getState().account.userData;

  const [id, setId] = useState(location?.state?.userName || "");

  const getUsersWithUserType = async () => {
    let userTypeGet;
    if (userType?.toUpperCase() === "SUB_ADMIN") {
      userTypeGet = 'ADMIN';
    } else if (userType?.toUpperCase() === "MASTER") {
      userTypeGet = 'SUB_ADMIN';
    }
    else if (userType?.toUpperCase() === "SUPER_AGENT") {
      userTypeGet = 'MASTER';
    }
    else if (userType?.toUpperCase() === "AGENT") {
      userTypeGet = 'SUPER_AGENT';
    }
    else if (userType?.toUpperCase() === "CLIENT") {
      userTypeGet = 'AGENT';
    }
    setLoading(true);
    setUserType(userTypeGet);
    const { response } = await getUsersWithUserTypeAPI(userTypeGet);
    let response_ = response;
    if (response_) {
      setLoading(false);
      setGetUsersWithUsers(response_)
      setGetUsersWithUsers(response_)

    }
    else {
      setLoading(false);
    }
  };
  const handleActiveInactive = async (userData) => {
    const { response, code } = await updateUserStatusAPI(userData?.uid, !userData?.isActive, userData?.isBetLocked);
    if (code == 200) {
      getClient()
      toast.success(`User status changed`)
    }
    else {
      response && toast.error(response)
    }
  }
  const getClient = async (search) => {
    setLoading(true)
    const { response } = await getClientAPI(
      search = search,
      currentPage,
      size,
      id,
      userName ? "" : userType?.toUpperCase(),
      location?.state?.blocked,
      isActive != null ? isActive : null,
      userName
    );
    let response_ = response;
    if (response_) {
      response_.childrenUserResponseDTOS = response_.childrenUserResponseDTOSPage.content.sort(
        (a, b) => a.uid - b.uid
      );
      setCurrentPage(response_.childrenUserResponseDTOSPage.number);
      setTotalPages(response_.childrenUserResponseDTOSPage.totalPages);
      setTotalElements(response_.childrenUserResponseDTOSPage.totalElements);
      setSize(response_.childrenUserResponseDTOSPage.size);
    }
    setLoading(false)
    setClientData(response_);
  };

  const navigate = useNavigate();
  useEffect(() => {
    getClient();
    getUsersWithUserType();
  }, [location.state, location.search, location.pathname, size,
    currentPage,]);

  const handleSelectChangeUser = (selectedOptions) => {
    const userIds = selectedOptions?.value;
    console.log(selectedOptions)
    setGetUserId(userIds);
    setSelectedUsers(selectedOptions);
  };
  // table 

  const [expandedRow, setExpandedRow] = useState(null);
  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const shareDetails = async (client) => {
    // Detect Safari (exclude Chrome & other browsers)
    const isSafari =
      /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const { response, code } = await sendLoginDetailsAPI(client?.uid);
    if (code === 200) {
      if (!isSafari) {
        const url = `https://api.whatsapp.com/send?text=
        New Password
        %0ALink: ${client?.userType?.toLowerCase() === "client"
            ? `https://${process.env.REACT_APP_APP_NAME}.net`
            : `https://operator.${process.env.REACT_APP_APP_NAME}.net`}
        %0AId: ${client?.username}
        %0APassword: ${response?.password}`;
        window.open(url, "_blank");
      }
      else {
        setShowSendLoginDetails({
          username: client?.username,
          password: response?.password,
          userType: client?.userType,
        })
      }
    } else {
      toast.error(response || "Something went wrong");
    }
  };

  const ROLE_HIERARCHY = {
    SUPER_ADMIN: "ADMIN",
    ADMIN: "SUB_ADMIN",
    SUB_ADMIN: "MASTER",
    MASTER: "SUPER_AGENT",
    SUPER_AGENT: "AGENT",
    AGENT: "CLIENT",
  };

  const handleNewClick = () => {
    const users = userTypeList?.users ?? [];
    if (!users.length) return;

    const loggedInRole = userData?.userType?.toUpperCase();
    const creatingRole = userType?.toUpperCase();

    const autoCreateRole = ROLE_HIERARCHY[loggedInRole];

    // ✅ CONDITION 1:
    // If creating immediate lower role → auto select logged-in user
    if (autoCreateRole === creatingRole) {
      const firstUser = users[0]; // parent user

      const selectedUserData = {
        value: firstUser.userId,
        label: `${firstUser.userName} ${firstUser.name}`,
      };

      setGetUserId(firstUser.userId);
      setSelectedUsers(selectedUserData);

      navigate(`/create/new/${userType}`, {
        state: {
          userId: firstUser.userId,
          selectedUsers: selectedUserData,
        },
      });
      return;
    }

    // ✅ CONDITION 2:
    // If only ONE user & same role → auto select
    const sameUserType =
      creatingRole === loggedInRole;

    if (users.length === 1 && sameUserType) {
      const firstUser = users[0];
      const selectedUserData = {
        value: firstUser.userId,
        label: `${firstUser.userName} ${firstUser.name}`,
      };
      setGetUserId(firstUser.userId);
      setSelectedUsers(selectedUserData);
      navigate(`/create/new/${userType}`, {
        state: {
          userId: firstUser.userId,
          selectedUsers: selectedUserData,
        },
      });
      return;
    }
    // ✅ OTHERWISE → show modal
    const modalEl = document.getElementById("modal-default");
    if (modalEl && window.bootstrap?.Modal) {
      const modal = new window.bootstrap.Modal(modalEl);
      modal.show();
    }
  };

  const handleUpdateCommission = async (amount, user) => {
    try {
      const { response, code } = await updateCommissionAPI({
        currentLimit: user?.isDeposit ? amount : -amount,
        id: user?.uid,
      });

      if (code === 200) {
        toast.success("Balance Updated Successfully");
        setShowDeposit(false)
        getClient();
        setAmount(null);
      } else {
        toast.error(response);
      }
    } catch (e) {
      // toast.error("Something went wrong");
    }
  };

  const [userUnsettledBets, setUserUnsettledBets] = useState(false);
  const getUnsettledBetByUsername = async (username) => {
    setLoading(true);
    const {
      response: { content },
    } = await unSettledBetsAPI({
      pageSize: 1000,
      pageNumber: 0,

      betStatus: "MATCHED",
    });
    setLoading(false);
    setUserUnsettledBets(
      content?.filter((item) => item.userName?.split(" ")[0] == username)
    );
  };

  const updateClientStatus = async (client, updatedFields, messages) => {
    try {
      const payload = {
        isActive: client.isActive,
        isBetLocked:
          updatedFields.isBetLocked ?? client.isBetLocked,
        isCasinoLocked:
          updatedFields.isCasinoLocked ?? client.isCasinoLocked,
        isMatkaLocked:
          updatedFields.isMatkaLocked ?? client.isMatkaLocked,
      };

      const { response, code } = await ChangeClientStatusAPI(
        client.uid,
        payload.isActive,
        payload.isBetLocked,
        payload.isCasinoLocked,
        payload.isMatkaLocked
      );

      if (code === 200) {
        getClient();
        toast.success(messages.success, {
          style: { background: "green", color: "#fff" },
        });
      } else {
        toast.error(response || messages.error, {
          style: { background: "red", color: "#fff" },
        });
      }
    } catch (error) {
      toast.error("Unexpected error occurred");
      console.error(error);
    }
  };


  const onStatusClick = (user) => {
    setSelectedUser(user);
    setConfirmModal(true);
  };

  const handleChangePassword = (client) => {
    setChangePassword(true);
    setClientPasswordData(client)
  };


  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [oldPassword, setOldPassword] = React.useState("");

  const dispatch = useDispatch();

  const changePasswordhandle = async () => {
    console.log(clientPasswordData)
    if (password === "" || confirmPassword === "") {
      toast.error("Please fill all the fields");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Password does not match");
      return;
    }
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return;
    }
    var { data, code, message, response, error } = await changePasswordAPI(
      {
        newPassword: Encrypt(password),
        password: Encrypt(oldPassword),
        resetRequired: false,
        uid: clientPasswordData.uid,
      },
      userData.token
    );
    if (code === 200) {
      toast.success("Password changed successfully");
      dispatch({
        type: "gameData/logOut",
        payload: {},
      });
      dispatch({
        type: "accountData/logOut",
        payload: {},
      });
      localStorage.removeItem("userData");
      localStorage.clear();
      window.location.href = "/";
    } else {
      toast.error(message);
    }
  };

  const getLimitUpdateItem = (userType, client, navigate) => {
    const type = userType?.toUpperCase();
    const config = {
      ADMIN: {
        path: "SUB_ADMIN",
        label: "Sub Admin Limit Update",
      },
      SUB_ADMIN: {
        path: "MASTER",
        label: "Master Limit Update",
      },
      MASTER: {
        path: "SUPER_AGENT",
        label: "Super Agent Limit Update",
      },
      SUPER_AGENT: {
        path: "AGENT",
        label: "Agent Limit Update",
      },
      AGENT: {
        path: "CLIENT",
        label: "Client Limit Update",
      },
    };

    if (!config[type]) return null;

    return {
      key: "limit-update",
      label: config[type].label,
      onClick: () =>
        navigate(`/update/limit/${config[type].path}`, {
          state: { client },
        }),
    };
  };


  return (
    <>
      {showSendLoginDetails && (
        <SendLoginDetails
          show={showSendLoginDetails}
          setShow={setShowSendLoginDetails}
        />
      )}

      <Modal
        className="sitemoadal"
        show={confirmModal}
        onHide={() => setConfirmModal(false)}
        centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: '#6610f2' }}>
            Confirmation Model
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-red">
            Are you sure you want to{" "}
            <strong>
              {selectedUser?.isActive ? "Deactivate" : "Activate"}
            </strong>{" "}
            this user?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-default pull-left cancel-button"
            onClick={() => setConfirmModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={async () => {
              await handleActiveInactive(selectedUser);
              setConfirmModal(false);
            }}
          >
            Yes, Confirm
          </button>
        </Modal.Footer>
      </Modal>


      {userUnsettledBets && (
        <Modal className="sitemoadal "
          show={userUnsettledBets}
          onHide={() => setUserUnsettledBets(false)}
        >
          <Modal.Header>
            <Modal.Title className="" style={{ color: '#6610f2' }}>Unsettled Bets</Modal.Title>
            <button
              type="button"
              className="btn-close btn-close-1"
              aria-label="Close"
              onClick={() => setUserUnsettledBets(false)}
            >
              Close
            </button>
          </Modal.Header>
          <Modal.Body className="modal-lg">
            <div className="custom_table">
              <div className="table-responsive height-500">
                <table className="table">
                  <thead className="ant-table-thead">
                    <tr>
                      <th className="textoftable">SNo</th>
                      <th className="textoftable">Event Name</th>
                      <th className="textoftable">Runner Name</th>
                      <th className="textoftable">Rate</th>
                      <th className="textoftable">Run</th>
                      <th className="textoftable">Mode</th>
                      <th className="textoftable">Amount</th>
                      <th className="textoftable">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userUnsettledBets.map((bet, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{bet.event_name}</td>
                        <td>{bet.runner_name}</td>
                        <td>{bet.back_rate || bet?.lay_rate}</td>
                        <td> {bet?.marketName !== 'BOOKMAKER_ODDS_1' ? (bet.back_run || bet.lay_run) : '-'}</td>
                        <td>
                          {bet?.marketName == "BOOKMAKER_ODDS_1"
                            ? bet?.back_rate
                              ? "LAGAI"
                              : "KHAI"
                            : bet?.back_rate
                              ? "YES"
                              : "NO"}
                        </td>
                        <td>{bet.amount}</td>

                        <td>
                          {moment(bet?.created_date + "Z").format(
                            "DD-MM-YYYY hh:mm A"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      <div className="content-wrapper">

        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>{userType?.toUpperCase()} LIST</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">{userType?.toUpperCase()} LIST</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {/* /.card */}
                <div className="card">
                  <div className="card-header border-none p-1">
                    <div className="form-group d-flex wrap" style={{ gap: "5px" }}>
                      {userType?.toUpperCase() == 'ADMIN' || 
                       userType?.toUpperCase() == 'CONTROLLER' ?
                        <>
                          <Link to={`/create/new/${userType}`}
                            type="button"
                            className="btn btn-primary">
                            New <i className="fa fa-plus-circle" />
                          </Link>
                        </> :
                        <>
                          <button
                            className="btn btn-primary"
                            type="button"
                            onClick={handleNewClick}
                          >
                            New <i className="fa fa-plus-circle" aria-hidden="true" />
                          </button>
                        </>}
                      <button
                        className="btn btn-success"
                        id="allActive"
                        type="submit"
                        name="check"
                        value={1}
                      >
                        All Active
                      </button>
                      <button
                        className="btn btn-danger"
                        id="allInActive"
                        type="submit"
                        name="check"
                        value={0}
                      >
                        All Deactive <i className="fa fa-ban" />
                      </button>
                      {/* {userType?.toUpperCase() !== "CLIENT" ? <> */}
                      {PERMISSION_MAP_CLIENT[userData?.userType?.toUpperCase()] === userType?.toUpperCase() && (
                        <Link
                          to={`/update_limit/${userType}`}
                          type="button"
                          className="btn btn-primary"
                        >
                          Limit Update
                        </Link>
                      )}
                      {/* </> : null} */}
                    </div>
                  </div>
                  <div className="card-body client">
                    {/* /.card-header */}
                    {loading ?
                      <Loader isLoading={loading} /> :
                      <div className="">
                        <div
                          className="dataTables_wrapper dt-bootstrap4 no-footer"
                        >
                          <div className="row">
                            <div className="col-sm-12 col-md-6" />
                            <div className="col-sm-12 col-md-6">
                              <div
                                id="example1_filter"
                                className="dataTables_filter "
                              >
                                <label className="d-flex align-items-center justify-content-end"
                                  style={{ gap: '5px' }}
                                >
                                  {/* Search: */}
                                  <input
                                    type="search"
                                    onChange={(e) => { setSearch(e.target.value) }}
                                    className="form-control form-control-sm"
                                    placeholder=""
                                    value={search}
                                    aria-controls="example1"
                                  />
                                  <span style={{ height: '31px' }}
                                    onClick={() => getClient(search)}
                                    className="btn btn-primary px-2 d-flex justify-content-center align-items-center rounded cursor-pointer">Search</span>
                                  <span style={{ height: '31px' }}
                                    onClick={() => { setSearch(''); getClient(null) }}
                                    className="btn btn-danger px-2 d-flex justify-content-center align-items-center rounded cursor-pointer">Reset</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                             
                                <div className="table-responsive bg-white">
                                  <table className="table table-bordered dataTable no-footer dtr-inline">
                                    <thead>
                                      <tr role="row">
                                        {/* <th className="d-md-none"></th> */}

                                        <th className="sorting_disabled">Sr.No</th>
                                        <th className="sorting_disabled">#</th>
                                        <th className="sorting_disabled">CODE</th>
                                        <th className="sorting_disabled">Name</th>
                                        <th className="sorting_disabled d-md-table-cell">Mobile</th>
                                        <th className="sorting_disabled d-md-table-cell">Password</th>
                                        {/* <th className="sorting_disabled d-md-table-cell">Limit</th>
                                        <th className="sorting_disabled d-md-table-cell">Match</th>
                                        <th className="sorting_disabled d-md-table-cell">Session</th>
                                        <th className="sorting_disabled d-md-table-cell">Share</th> */}
                                        <th className="sorting_disabled d-md-table-cell">Status</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {clientData?.childrenUserResponseDTOS?.map((client, index) => (
                                        <React.Fragment key={index}>
                                          <tr role="row">

                                            <td>{index + 1}</td>


                                            <td>
                                              <Dropdown
                                                trigger={["click"]}
                                                menu={{
                                                  items: [
                                                   
                                                    {
                                                      key: "inactive",
                                                      label: client?.isActive ? "Inactive" : "Active",
                                                      onClick: () => handleActiveInactive(client)
                                                    },
                                                    {
                                                      key: "block-betting",
                                                      label: client?.isActive ? "Block Betting" : "UnBlock Betting",
                                                      onClick: () => onStatusClick(client)
                                                    },
                                                    {
                                                      key: "block-casino",
                                                      label: client?.isCasinoLocked ? "UnBlock Casino" : "Block Casino",
                                                      onClick: () => {
                                                        updateClientStatus(
                                                          client,
                                                          { isCasinoLocked: !client.isCasinoLocked },
                                                          {
                                                            success: client?.isCasinoLocked
                                                              ? "Casino activated"
                                                              : "Casino blocked",
                                                            error: "Failed to update casino status",
                                                          }
                                                        );
                                                      },
                                                    },
                                                    getLimitUpdateItem(userType, client, navigate),
                                                    // ---- bold section ----
                                                    {
                                                      type: "divider",
                                                    },
                                                    {
                                                      key: "edit",
                                                      label: <strong>Edit</strong>,
                                                      onClick: () =>
                                                        navigate(`/${userType}/edit/${client.uid}`, {
                                                          state: { client },
                                                        }),
                                                    },
                                                    
                                                  ],
                                                }}>
                                                <Button
                                                  type="primary"
                                                  size="small"
                                                  icon={
                                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M128 192l128 128 128-128z"></path></svg>
                                                  }
                                                />
                                              </Dropdown>
                                            </td>
                                            <td className="d-flex align-items-center gap-3"
                                              style={{ gap: '5px' }}
                                              // onClick={() =>
                                              //   client?.userType != "CLIENT" &&
                                              //   navigate(
                                              //     `/${PERMISSION_MAP_CLIENT[
                                              //     client?.userType
                                              //     ]
                                              //     }/${client?.username}`
                                              //   )
                                              // }
                                              >&nbsp;&nbsp;
                                              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path></svg>
                                              {client.username}&nbsp;

                                              {/* </a> */}
                                              &nbsp;&nbsp;&nbsp;
                                            </td>


                                            <td>
                                              <div className="d-flex align-items-center justify-content-between" style={{ gap: "5px" }}>
                                                {client.name}
                                                <span
                                                  onClick={() => {
                                                    shareDetails(client);
                                                  }}
                                                >
                                                  {" "}
                                                  <svg
                                                    stroke="currentColor"
                                                    fill="currentColor"
                                                    strokeWidth={0}
                                                    viewBox="0 0 16 16"
                                                    className="text-success"
                                                    height="1em"
                                                    width="1em"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                                                  </svg>{" "}
                                                </span>
                                              </div>
                                            </td>

                                            {/* Desktop only */}
                                            <td className="d-md-table-cell">{client.mobile}</td>
                                            <td className="d-md-table-cell">{client.password}</td>
                                            {/* <td className="d-md-table-cell">
                                              {client.balance?.toFixed(2)}
                                            </td>
                                            <td className="d-md-table-cell">
                                              {client.matchCommission}
                                            </td>
                                            <td className="d-md-table-cell">
                                              {client.sessionCommission}
                                            </td>
                                            <td className="d-md-table-cell">
                                              {client.myPartnership}
                                            </td> */}

                                            <td className="d-md-table-cell">
                                              {client.isActive ? (
                                                <span className="badge bg-success">Active</span>
                                              ) : (
                                                <span className="badge bg-danger">Deactive</span>
                                              )}
                                            </td>
                                          </tr>
                                        </React.Fragment>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                            
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-5" />
                            <div className="col-sm-12 col-md-7" />
                          </div>
                        </div>
                      </div>
                    }
                    {/* /.card-body */}
                    <div className="row">
                      <div className="col-sm-12 col-md-5">
                        <div
                          className="dataTables_info"
                          id="example1_info"
                          role="status"
                          aria-live="polite"
                        >
                          Showing &nbsp;
                          {currentPage * size + 1} to{" "}
                          {currentPage * size + size > totalElements
                            ? totalElements
                            : currentPage * size + size}{" "}
                          of {totalElements} entries
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-7">
                        <div
                          className="dataTables_paginate paging_simple_numbers"
                          id="example1_paginate"
                        >
                          <ul className="pagination justify-content-end align-items-center">
                            {/* Previous */}
                            <li
                              className={`page-item ${currentPage === 0 ? "disabled" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => {
                                  if (currentPage > 0) {
                                    setCurrentPage(currentPage - 1);
                                  }
                                }}
                                disabled={currentPage === 0}
                              >
                                Previous
                              </button>
                            </li>

                            {/* Current Page */}
                            <li className="page-item active">
                              <span className="page-link">
                                {currentPage + 1} / {totalPages}
                              </span>
                            </li>

                            {/* Next */}
                            <li
                              className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => {
                                  if (currentPage < totalPages - 1) {
                                    setCurrentPage(currentPage + 1);
                                  }
                                }}
                                disabled={currentPage === totalPages - 1}
                              >
                                Next
                              </button>
                            </li>
                          </ul>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card */}
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section >
        {/* /.content */}
        {/* /.content */}
        <section className="content">
          <div className="modal fade" id="modal-default">
            <div className="modal-dialog">
              <form>
                <input type="hidden" name="_method" defaultValue="PUT" />
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Select {userTypeName}</h4>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <ReactSelect
                      options={userTypeList?.users?.map(user => ({
                        value: user.userId,
                        label: `${user.userName + ` ` + user.name}`,
                      }))}
                      // value={selectedUsers}
                      onChange={handleSelectChangeUser}
                    />

                    {/* <select id="agent" className="form-control"
                    onChange={handleSelectChangeUser}
                  >
                    <option> Please Select</option>
                    {userTypeList?.users?.map((item, index) => (
                      <option value={item.userId}> {item.userName} {item.name}</option>
                    ))}
                  </select> */}
                  </div>
                  <div className="modal-footer justify-content-between">
                    <button
                      type="button"
                      className="btn btn-default"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      data-dismiss="modal"
                      onClick={() => {
                        let userTypeGet = userType;

                        if (userType?.toUpperCase() === "SUPER_ADMIN") {
                          userTypeGet = "ADMIN";
                        }
                        if (userType?.toUpperCase() === "SUB_ADMIN") {
                          userTypeGet = "ADMIN";
                        }

                        navigate(`/create/new/${userType}`, {
                          state: {
                            userId,
                            selectedUsers,
                          },
                        });
                      }}

                      id="Agentpath"
                      type="button"
                      className="btn btn-primary">
                      Continue
                    </button>
                  </div>
                </div>
              </form>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
        </section>
      </div >

      {/* Deposit Modal */}
      {
        depositModal &&
        <div
          className="modal"
          style={{ display: 'block' }}
          id="depositChipsModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">
                  {selectedClientDW?.isDeposit ? "Deposit Model" : "Withdraw Model"}</h4>
              </div>
              <div className="modal-body">
                <div className="subowner-share">
                  <label htmlFor="parent-coins">Parent Limit</label>
                  <input
                    type="number"
                    min={0}
                    placeholder={0}
                    className="form-control"
                    readOnly
                    id=""
                    name="parent-coins"
                    defaultValue={selectedClientDW?.parentLimit}
                  />
                </div>
                <div className="subowner-share">
                  <label htmlFor="coins">Client Limit</label>
                  <input
                    type="number"
                    value={amount}
                    onChange={(e) => {
                      setAmount(e.target.value);
                    }}
                    min={0}
                    placeholder="Client Limit"
                    className="form-control"
                    id=""
                    name="coins"
                    defaultValue={0}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default pull-left cancel-button"
                  data-dismiss="modal"
                  onClick={() => setShowDeposit(false)}
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={() => handleUpdateCommission(amount, selectedClientDW)}>
                  {selectedClientDW?.isDeposit ? "Deposit" : "Withdraw"}
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      {
        depositModal &&
        <div class="modal-backdrop fade show"></div>
      }

      {
        changePassword &&
        <div className="modal"
          style={{ display: 'block' }}
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Change Password Model</h4>
              </div>
              <div className="modal-body">
                <div className="subowner-share">
                  <label htmlFor="newPassword">New Password</label>
                  <input
                    type="text"
                    onChange={(e) => setOldPassword(e.target.value)}
                    className="form-control"
                    placeholder="Enter Current Password"
                    id="newPassword"
                    required=""
                    name="newPassword"
                    defaultValue=""
                  />
                </div>
                <div className="subowner-share">
                  <label htmlFor="confirmPassword">Confirm Password</label>
                  <input
                    type="text"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="form-control"
                    placeholder="Enter New Password"
                    id="confirmPassword"
                    required=""
                    name="confirmPassword"
                    defaultValue=""
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default pull-left cancel-button"
                  data-dismiss="modal"
                  onClick={() => setChangePassword(false)}
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary"
                  onClick={changePasswordhandle}>
                  Change Password
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      {
        changePassword &&
        <div class="modal-backdrop fade show"></div>
      }
    </>
  );
}
